export default {"src":"/_next/static/media/worpel-bold.ba7ee579.svg","height":44,"width":309};